export const gridTotalItemsLabel = 'Totale : {2} elementi'
export const titlePageInitialLabel = 'Qs Web Admin'
